<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择销售订单"
      width="800px"
      top="5vh"
  >
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="sapSalesOrders"
        @select="selectSalesOrder">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="订单编号" prop="salesOrderNo">
            <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入销售订单编号"/>
          </el-form-item>
          <el-form-item label="客户名称" prop="customer">
            <el-input v-model.trim="filter.customer" placeholder="请输入客户名称"/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {
          salesOrderNo: "",
          customer: "",
          status:30,
        },
        columns: [
          {
            title: "订单编号",
            key: "billNo",
            width: 140,
            align: "center",
          },
          {
            title: "合同编号",
            key: "customerContractNo",
            width: 140,
            align: "center",
          },
          {
            title: "客户名称",
            key: "customerName",
          },
          {
            title: "订单类型",
            key: "salesOrderCategoryName",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
            fixed: "left",
          },
        ],
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        // 清空查询条件
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },


      selectSalesOrder(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle(filter) {
        this.filter = filter;
        this.$nextTick(() => {
          this.$refs.tableSelect.loadData();
        });
      },
    },
  };
</script>
